export const RESET_UPLOAD_LIST = "reset_upload_list";
export const CHANGE_UPLOAD_LIST_FIELD = "change_upload_list_field";
export const HEADER_VALIDATION_SUCCESS = "header_validation_success";
